import React, { useEffect } from 'react';

const GoogleTranslate = () => {
  useEffect(() => {
    const addGoogleTranslateScript = () => {
      const script = document.createElement('script');
      script.src = 'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
      script.async = true;
      document.body.appendChild(script);
    };
 
    window.googleTranslateElementInit = () => {
      new window.google.translate.TranslateElement(
        {
          pageLanguage: 'en',
          includedLanguages: 'en,hi,pa,gu,bn,mr,te,ta,kn,ml',
          layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
          autoDisplay: false
        },
        'google_translate_element'
      );

      // Hide extra Google elements
      const interval = setInterval(() => {
        const unwanted = document.querySelector('.VIpgJd-ZVi9od-ORHb');
        if (unwanted) unwanted.style.display = 'none';
      }, 500);

      return () => clearInterval(interval);
    };

    setTimeout(addGoogleTranslateScript, 1000);
  }, []);

  return (
    <>
      <style>
        {`
          iframe#\\:2\\.container {
            display: none;
          }

          .google-translate-container {
            display: block;
            justify-content: center;
            align-items: center;
            padding: 10px;

          }

          .goog-te-combo {
            width: 250px;
            padding: 10px;
            border: none;
            border-radius: 8px;
            background-color: #f8f9fa;
            font-size: 16px;
            color: #333;
            transition: all 0.3s ease-in-out;
            box-shadow: none;
          }

          .goog-te-combo:hover,
          .goog-te-combo:focus {
            background-color: #ffffff;
            outline: none;
          }

          #google_translate_element {
            display: block;
            text-align: center;
          }

          .goog-te-banner-frame {
            display: none !important;
          }

          .goog-te-gadget {
            font-size: 0px !important;
          }

          .goog-te-gadget span {
            display: none;
          }
        `}
      </style>

      <div className="google-translate-container">
        <div id="google_translate_element"></div>
      </div>
    </>
  );
};

export default GoogleTranslate;
  